import { compose } from 'recompose'
import CurrentTireSize from './CurrentTireSize'

export default compose()(CurrentTireSize)
